import { Select, SelectProps } from 'antd';
import { observer } from 'mobx-react-lite';
import { BaseSelectRef } from 'rc-select';
import * as React from 'react';

import { EntrySelect } from 'stores/models';

type EntrySelectFieldProps<T extends string = string> = SelectProps & {
  model: EntrySelect<T>;
  textMapper?: Record<T, string>;
  error?: boolean;
  disabled?: boolean;
};

/** Компонент-обёртка для связи модели текстового ввода с инпутом из uikit*/
const EntrySelectField: React.FC<EntrySelectFieldProps> = React.forwardRef(
  (
    { model, disabled, error, textMapper, ...props },
    ref: React.Ref<BaseSelectRef>
  ) => {
    const handleSelect = React.useCallback(
      (value) => {
        model.setValue(value);
      },
      [model]
    );

    return (
      <Select
        ref={ref}
        value={model.value}
        onChange={handleSelect}
        onBlur={model.touch}
        disabled={model.disable || disabled}
        status={model.errorIfTouched.value || error ? 'error' : ''}
        {...props}
      >
        {model.options.map((item) => (
          <Select.Option key={item}>{textMapper?.[item] || item}</Select.Option>
        ))}
      </Select>
    );
  }
);

export default observer(EntrySelectField);
